interface LoadingStateProps {
  loading: boolean
  error: string | null
}

export function LoadingState({ loading, error }: LoadingStateProps) {
  if (loading) {
    return (
      <div className="h-full flex flex-col gap-3 p-4 animate-pulse" data-testid="table-loading-skeleton">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="h-10 rounded bg-surface-muted" />
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center p-4">
        <div className="text-danger bg-danger-subtle px-4 py-3 rounded-lg">Error: {error}</div>
      </div>
    )
  }

  return null
}
